var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app" },
    [
      _vm.item
        ? [
            _vm.item.images.length > 0
              ? _c("Images", {
                  attrs: { images: _vm.item.images, media: _vm.media }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("section", { class: _vm.getClassName("headline") }, [
              _c(
                "div",
                { class: _vm.getClassName("headline__wrapper") },
                [
                  _c("h1", { class: _vm.getClassName("headline__title") }, [
                    _c(
                      "span",
                      { class: _vm.getClassName("headline__category") },
                      [_vm._v(_vm._s(_vm.item.category.name))]
                    ),
                    _vm._v(
                      "\n          " + _vm._s(_vm.item.name) + "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("Favorite", {
                    attrs: { form: _vm.form, user: _vm.user, media: _vm.media },
                    on: { alert: _vm.applyAlert, user: _vm.applyUser }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", {
                class: _vm.getClassName("headline__summary"),
                domProps: { innerHTML: _vm._s(_vm.item.summary) }
              })
            ]),
            _vm._v(" "),
            _c("Purchase", {
              attrs: {
                item: _vm.item,
                "enable-cart": _vm.enableCart,
                media: _vm.media
              },
              on: { alert: _vm.applyAlert },
              model: {
                value: _vm.form,
                callback: function($$v) {
                  _vm.form = $$v
                },
                expression: "form"
              }
            }),
            _vm._v(" "),
            _c("UserReviews", {
              attrs: {
                item: _vm.item,
                user: _vm.user,
                reviews: _vm.item.reviews,
                media: _vm.media
              },
              on: { alert: _vm.applyAlert }
            }),
            _vm._v(" "),
            _vm.enableSimulator
              ? _c("Simulator", { attrs: { item: _vm.item, media: _vm.media } })
              : _vm._e(),
            _vm._v(" "),
            _c("Alert", {
              attrs: {
                visible: _vm.alert.visible,
                varient: _vm.alert.varient,
                messages: _vm.alert.messages,
                media: _vm.media
              },
              on: {
                hide: function($event) {
                  _vm.alert.visible = false
                }
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("Loading", { attrs: { "is-show": _vm.item === null } })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }